// extracted by mini-css-extract-plugin
export var completionBody = "_ds-2";
export var completionCard = "_ds-0";
export var completionFooter = "_ds-3";
export var completionTitle = "_ds-1";